import { all, put, call, select, takeEvery } from 'redux-saga/effects'
import store from 'store'
import { getLeftMenuData, getTopMenuData } from 'services/menu'

const getCurrentUser = state => state.user

export function* GET_DATA() {
  const currentUser = yield select(getCurrentUser)
  if (currentUser.token) {
    const menuLeftData = yield call(getLeftMenuData, currentUser.token)
    if (menuLeftData) {
      const menuTopData = yield call(getTopMenuData, currentUser.token)
      yield store.set('app.menuLeftData', menuLeftData)
      yield put({
        type: 'menu/SET_STATE',
        payload: {
          menuLeftData,
          menuTopData,
        },
      })
    } else {
      yield put({ type: 'user/LOGOUT' })
    }
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery('menu/GET_DATA', GET_DATA), // run once on app load to fetch menu data
    GET_DATA(),
  ])
}
